import React from 'react';

const PendingStatus = ({
  width = 16,
  height = 16,
  className,
  color,
  ...rest
}) => {
  return (
    <svg
      role="presentation"
      aria-hidden="true"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      {...rest}
    >
      <circle cx="8" cy="8" r="8" fill="#8250DF" />
      <path
        d="M4.57031 11.1104C4.57031 10.8682 4.76663 10.6719 5.00881 10.6719H11.1477C11.3899 10.6719 11.5862 10.8682 11.5862 11.1104C11.5862 11.3525 11.3899 11.5489 11.1477 11.5489H5.00881C4.76663 11.5489 4.57031 11.3525 4.57031 11.1104Z"
        fill="white"
      />
      <path
        d="M4.57031 9.13771C4.57031 8.89554 4.76663 8.69922 5.00881 8.69922H11.1477C11.3899 8.69922 11.5862 8.89554 11.5862 9.13771C11.5862 9.37989 11.3899 9.57621 11.1477 9.57621H5.00881C4.76663 9.57621 4.57031 9.37989 4.57031 9.13771Z"
        fill="white"
      />
      <path
        d="M4.57031 5.76172C4.57031 5.20943 5.01803 4.76172 5.57031 4.76172H10.5862C11.1385 4.76172 11.5862 5.20943 11.5862 5.76172V6.83118C11.5862 7.38347 11.1385 7.83118 10.5862 7.83118H5.57031C5.01803 7.83118 4.57031 7.38347 4.57031 6.83118V5.76172Z"
        fill="white"
      />
    </svg>
  );
};

export { PendingStatus };
